<template>
	<div class="items-content">
		<div class="title">{{ detail.title }}</div>
		<div class="wrap">
			<div class="content ck-content" v-html="detail.content"></div>
		</div>
	</div>
</template>

<script>
import ajax from "@/api/ajax";
export default {
	name: "contentComponent",
	data() {
		return {
			detail: {}
		};
	},
	components: {},
	computed: {},
	async created() {
		this.$route.meta.cmsApi &&
			ajax[this.$route.meta.cmsApi]().then(res => {
				this.detail = res[0];
			});
	}
};
</script>

<style lang="scss" scoped>
.items-content {
	.title {
		font-size: 0.44rem;
		color: #333333;
		font-weight: bold;
		text-align: center;
		margin: 0.6rem 0;
		background-color: #fff;
	}
	.wrap {
		margin-bottom: 0.6rem;
		&:last-child {
			margin-bottom: 0;
		}
		.content {
			position: relative;
			padding: 0.2rem;
			>>> h2 {
				font-size: 0.34rem;
			}
		}
		img {
			display: block;
			max-width: 100%;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/investorRelations/content.vue